import React from 'react';

import Tooltip from '@atlaskit/tooltip';

import { IssuePriority } from '@qality/common-model';

import { ContainerStyled } from './IssuePriorityIcon.styled';

type Props = { priority?: IssuePriority };

export default function IssuePriorityIcon({ priority }: Props): JSX.Element {
  if (!priority) {
    return null;
  }

  return (
    <ContainerStyled>
      <Tooltip content={priority.name}>
        <img
          src={priority.iconUrl}
          alt={priority.name}
          width='16'
          height='16'
        />
      </Tooltip>
    </ContainerStyled>
  );
}
